module.exports = __webpack_public_path__ + "assets/img/banner-services-1280.jpg";